// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","iconContainer":"Footer_iconContainer__6oHZ3","icon":"Footer_icon__m+93W"};